import { Helmet } from "react-helmet-async";

export default function SeoHead({
  title,
  description,
  keywords,
  url,
  image,
  author = "Dr. R. Suneel",
  publisher = "Dr. R. Suneel",
  schemaJson,
}) {
  return (
    <Helmet prioritizeSeoTags>
      {/* Basic SEO */}
      {title && <title>{title}</title>}

      {description && (
        <meta name="description" content={description} />
      )}

     {keywords && <meta name="keywords" content={keywords} />}

      <meta
        name="robots"
        content="FOLLOW, INDEX, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1, MAX-IMAGE-PREVIEW:LARGE"
      />

      <meta name="author" content={author} />
      <meta name="publisher" content={publisher} />

      {/* Canonical */}
      {url && <link rel="canonical" href={url} />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Hand & Wrist Clinics" />

      {title && (
        <meta property="og:title" content={title} />
      )}

      {description && (
        <meta property="og:description" content={description} />
      )}

      {url && (
        <meta property="og:url" content={url} />
      )}

      {image && (
        <meta property="og:image" content={image} />
      )}

      {/* Twitter */}
      <meta
        name="twitter:card"
        content="summary_large_image"
      />

      {title && (
        <meta name="twitter:title" content={title} />
      )}

      {description && (
        <meta
          name="twitter:description"
          content={description}
        />
      )}

      {image && (
        <meta
          name="twitter:image"
          content={image}
        />
      )}

      {/* Schema */}
      {schemaJson && (
        <script type="application/ld+json">
          {JSON.stringify(schemaJson)}
        </script>
      )}
    </Helmet>
  );
}